import { Fragment } from "react";
import { useSelector } from "react-redux";

function ListLanguage(props) {
  const { allLingos } = useSelector((state) => state.genericReducer);

  const handleSelects = (name, value, index) => {
    props.onChangeLanguages(name, value, index);
  };

  const { t, studentPlanLanguages } = props;

  return (
    <Fragment>
      {studentPlanLanguages.map((lang, index) => {
        let level = 0;
        if (props.level) {
          level = props.level;
        } else {
          level = lang.studentLanguageLevel;
        }
        return (
          <div style={{ display: "flex" }} key={"language-" + index}>
            <div className="lineInputs">
              <div>
                <label>
                  {t("LINGO")}
                  <span className="invalid">{t("REQUIRED")}</span>
                </label>
              </div>
              <select
                value={lang.lingoLanguageId}
                onChange={(e) => handleSelects("lingoLanguageId", Number(e.target.value), index)}
                className="input-lingo mediumSelect"
                name="studentPlanLanguage.lingoLanguageId"
                disabled={studentPlanLanguages.length > 1 ? true : false}
              >
                <option value="">{t("SELECT")}</option>
                {allLingos.map((i) => {
                  return (
                    <option key={i.id * 9} value={i.id}>
                      {i.language.name}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="lineInputs">
              <div>
                <label>{t("LEVEL")}</label>
              </div>
              <select
                style={{ width: "100px" }}
                value={level}
                name="studentPlanLanguage.studentLanguageLevel"
                onChange={(e) => handleSelects("studentLanguageLevel", Number(e.target.value), index)}
              >
                <option value="0">Select</option>
                <option value="1">A0</option>
                <option value="2">A1</option>
                <option value="3">A2</option>
                <option value="4">B1</option>
                <option value="5">B2</option>
                <option value="6">C1</option>
                <option value="7">C2</option>
                <option value="8">DM</option>
              </select>
            </div>
          </div>
        );
      })}
    </Fragment>
  );
}

export default ListLanguage;
